import { createStore, applyMiddleware } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { composeWithDevTools } from 'redux-devtools-extension'
import logger from 'redux-logger'
import thunk from 'redux-thunk'
import rootReducers from '../reducer'

const persistConfig = {
    key: 'root',
    storage
}

const persistedReducer = persistReducer(persistConfig, rootReducers)

export const store = createStore(
    persistedReducer,
    process.env.NODE_ENV === 'production' ? undefined : composeWithDevTools(applyMiddleware(logger, thunk))
)
export const persistor = persistStore(store)
